/* eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "../helpers/auth";
import navigationGuards from "./navigationGuards";

const Index = () => import("@/screens/Index/Main");
const Login = () => import("@/screens/Login/Main");
const SignIn = () => import("@/screens/Login/components/SignIn");
const RequestNewPassword = () =>
  import("@/screens/Login/components/RequestNewPassword");
const RenewPlan = () => import("@/screens/Renew/Main");
const ChangePassword = () =>
  import("@/screens/Login/components/ChangePassword");
const Class = () => import("@/screens/Class/Index/Main");
const Community = () => import("@/screens/Community/Main");
const CommunityUsers = () =>
  import("@/screens/Community/components/Users/Main");
const CommunityUserList = () =>
  import("@/screens/Community/components/Users/List");
const CommunityPosts = () =>
  import("@/screens/Community/components/Posts/Main");
const CommunityModeration = () =>
  import("@/screens/Community/components/Moderation/Main");
const CommunityPostsIndex = () =>
  import("@/screens/Community/components/Posts/Index");
const CommunityPostsShow = () =>
  import("@/screens/Community/components/Posts/Show");
const CommunityPostModeration = () =>
  import("@/screens/Community/components/Moderation/Posts");
const CommunityPostCommentModeration = () =>
  import("@/screens/Community/components/Moderation/Comments");
const CommunityNotifications = () =>
  import("@/screens/Community/components/Notifications/Main");
const CommunityUserNotificationsList = () =>
  import("@/screens/Community/components/Notifications/List");
const CommunityBookmarkedPosts = () =>
  import("@/screens/Community/components/Bookmarks/Main");
const CommunityPostBookmark = () =>
  import("@/screens/Community/components/Bookmarks/Posts");
const PageNotFound = () => import("@/screens/NotFound/Main");

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: Login,
    children: [
      { path: "/", component: SignIn, name: "signIn" },
      {
        path: "/password/forgot",
        component: RequestNewPassword,
        name: "forgotPassword",
      },
      {
        path: "/password/edit",
        component: ChangePassword,
        name: "changePassword",
      },
    ],
  },
  {
    path: "/renew",
    component: RenewPlan,
    name: "renewPlan",
  },
  {
    path: "/",
    name: "index",
    meta: { requiresAuth: true },
    component: Index,
  },
  {
    path: "/class/:slug?",
    name: "class",
    meta: { requiresAuth: true },
    component: Class,
    beforeEnter: navigationGuards.postAvailable,
  },
  {
    path: "/community/:communityId",
    meta: { requiresAuth: true },
    component: Community,
    children: [
      {
        path: "posts",
        component: CommunityPosts,
        children: [
          {
            path: "/",
            component: CommunityPostsIndex,
            name: "communityPosts",
            props: true,
          },
          {
            path: ":postId",
            component: CommunityPostsShow,
            name: "communityPostComments",
            props: true,
          },
        ],
      },
      {
        path: "moderation",
        component: CommunityModeration,
        meta: {
          moderation: true,
        },
        children: [
          {
            path: "posts",
            component: CommunityPostModeration,
            name: "communityPostModeration",
            beforeEnter: navigationGuards.communityModeration,
            meta: {
              moderation: true,
            },
          },
          {
            path: "comments",
            component: CommunityPostCommentModeration,
            name: "communityPostCommentModeration",
            beforeEnter: navigationGuards.communityModeration,
            meta: {
              moderation: true,
            },
          },
          {
            path: "users",
            component: CommunityUsers,
            children: [
              {
                path: "",
                component: CommunityUserList,
                name: "communityUserList",
                beforeEnter: navigationGuards.communityModeration,
                meta: {
                  moderation: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "bookmarks",
        component: CommunityBookmarkedPosts,
        children: [
          {
            path: "/",
            component: CommunityPostBookmark,
            name: "CommunityPostBookmark",
          },
        ],
      },
      {
        path: "notifications",
        component: CommunityNotifications,
        children: [
          {
            path: "",
            component: CommunityUserNotificationsList,
            name: "communityUserNotificationsList",
          },
        ],
      },
    ],
  },
  {
    path: "*",
    name: "notFound",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "active-class",
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((matchedRoute) => matchedRoute.meta.requiresAuth) &&
    !Auth.token.has()
  ) {
    return next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  }

  if (to.path === "/login" && Auth.token.has()) {
    return to.params.remoteRendering ? next("/login") : next("/");
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js